import {
    GET_BLOG_DETAILS_START,
    GET_BLOG_DETAILS_SUCCESS,
    GET_BLOG_DETAILS_ERROR,
    SHOW_BLOG_PHOTOS_SUCCESS,
    CREATE_BLOG_PHOTOS_SUCCESS,
    REMOVE_BLOG_PHOTOS_SUCCESS,
} from '../../constants';

export default function blogDetails(state = {}, action) {
  switch (action.type) {

    case GET_BLOG_DETAILS_START:
      return {
        ...state,/* 
        blogDetails: action.blogDetails,
        photosCount: action.photosCount,
        blogPhotos: action.blogPhotos, */
        isLoading: action.payload.isLoading
      };
    
    case GET_BLOG_DETAILS_ERROR:
      return {
        ...state,
        isLoading: action.payload.isLoading
      };
    
    case GET_BLOG_DETAILS_SUCCESS:
      return {
        ...state,
        isLoading: action.payload.isLoading,
        ...action.payload.blogDetails
      };
    
    case CREATE_BLOG_PHOTOS_SUCCESS:
      return {
        ...state,
        photosCount: action.photosCount
      };
  
    case REMOVE_BLOG_PHOTOS_SUCCESS:
      return {
        ...state,
        photosCount: action.photosCount
      };
    
    case SHOW_BLOG_PHOTOS_SUCCESS:
      return {
        ...state,
        blogPhotos: action.blogPhotos,
        photosCount: action.photosCount
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// src/reducers/siteadmin/blogDetails.js